import { LAYOUT_TYPE, NAV_STYLE, THEME_COLOR, THEME_TYPE } from '../../constants/ThemeSetting';

export default class SettingsAction {
  static ACTION_TYPES = {
    // Async actions

    // Sync actions
    SWITCH_LANGUAGE: 'SWITCH-LANGUAGE',
    TOGGLE_COLLAPSED_NAV: 'TOGGLE_COLLAPSED_NAV',
    WINDOW_WIDTH: 'WINDOW_WIDTH',
  };

  static toggleCollapsedSideNav(navCollapsed) {
    return {
      type: SettingsAction.ACTION_TYPES.TOGGLE_COLLAPSED_NAV,
      navCollapsed,
    };
  }

  static updateWindowWidth(width) {
    return { type: SettingsAction.ACTION_TYPES.WINDOW_WIDTH, width };
  }

  static switchLanguage(locale) {
    return {
      type: SettingsAction.ACTION_TYPES.SWITCH_LANGUAGE,
      payload: locale,
    };
  }

  static setThemeType(themeType) {
    return { type: THEME_TYPE, themeType };
  }

  static setThemeColor(themeColor) {
    return { type: THEME_COLOR, themeColor };
  }

  static onNavStyleChange(navStyle) {
    return { type: NAV_STYLE, navStyle };
  }

  static onLayoutTypeChange(layoutType) {
    return { type: LAYOUT_TYPE, layoutType };
  }
}
